import { Component } from "react";
import { apiGetP, apiPostP } from "../../GanjiTools";
import Uploader from "../Uploader";
import ScanButton from "../utils/ScanButton";
import GroupBox from "../utils/GroupBox";

export class AuxFile {

    static manageTemporaries(table, action/* keep or remove */, id, cat = null, comment = null) {
        apiPostP(`/api/tarabar/temporaryAuxFiles/${table}/${action}/${id ?? 0}`, { cat, comment }
        ).then(res => {
            let { done, error } = res ?? { error: 'No response.', done: '' };
            console.log('done', action, 'auxiliary files', done);

            if (error?.length > 0) {
                window.notif(error);
            }
        }).catch(window.notif)
    }

    static getTempPath(table, id) {
        return `aux_documents\\${table}\\${id ?? 0}\\_temp`;
    }

    static showList(table, id) {
        apiGetP(`/api/tarabar/auxFiles/${table}/${id}`)
            .then(console.log)
            .catch(window.notif);
        //window.notif('---- implement me! ' + table + id)//////////////////////////
    }
}

export default class PrepareAuxFile extends Component {

    render() {
        const subPath = AuxFile.getTempPath(this.props.table, this.props.rowId);

        return (
            <GroupBox title='مستندات' style={{ display: 'inline-flex' }}>
                <Uploader selectButtonText={'بارگذاری اسناد...'} subPath={subPath} />
                <ScanButton subPath={subPath}
                    scanServerUrl={window.config.SCAN_SERVER_URL ?? 'http://localhost:7001'} />
            </GroupBox>
        );
    }
}
